import { Tooltip } from "react-bootstrap";

export const renderTooltip = (props?: Record<string, any>, lead?: string) => (
  <Tooltip id="button-tooltip" {...props}>
    {lead?.replaceAll("&oacute;", "ó")}
  </Tooltip>
);
